import { render } from "./RotationPanel.vue?vue&type=template&id=1351c5d6&scoped=true&ts=true"
import script from "./RotationPanel.vue?vue&type=script&lang=ts"
export * from "./RotationPanel.vue?vue&type=script&lang=ts"

import "./RotationPanel.vue?vue&type=style&index=0&id=1351c5d6&scoped=true&lang=css"

import exportComponent from "/vue/cubetrain/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1351c5d6"]])

export default __exports__